import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import Avatar from '@mui/material/Avatar';

function PaymentLinkExpired() {
  return (
    <div className="auth loginbox main-content my-5">
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          background: '#fafafa',
          '& > :not(style)': {
            m: 1,
            // border: "1px solid #E5E5E5",
            boxShadow: '0px 4px 29px 0px rgba(0, 1, 1, 0.15)',
            borderRadius: '75px 0 75px'
          }
        }}
      >
        <Box
          sx={{
            m: 1,
            background: '#fff',
            width: 495,
            padding: '44px 50px 44px 44px',
            textAlign: 'center'
          }}
        >
          <Paper elevation={0}>
            <Avatar
              sx={{
                justifyContent: 'center',
                margin: '0  auto 20px',
                width: 65,
                height: 65,
                bgcolor: 'primary.main'
              }}
            >
              <LinkOffIcon />
            </Avatar>
            <Typography
              variant="h3"
              gutterBottom
              component="h3"
              mb={1}
              sx={{
                fontSize: '30px',
                fontWeight: 'bold'
              }}
            >
              Link Expired
            </Typography>
            <Typography variant="subtitle1" gutterBottom component="" mb={1}>
              This link has expired/invalid
            </Typography>
          </Paper>
        </Box>
      </Box>
    </div>
  );
}
export default PaymentLinkExpired;
